import axios from 'axios';
import CryptoJS from 'crypto-js';
import axiosIns, { API_URL, baseurl } from '../_config';
import toast from 'react-hot-toast';

const secretKey = CryptoJS.enc.Utf8.parse("uitsufdytuiysdifdsfdsfdhgtyuijkj");
const iv = CryptoJS.enc.Utf8.parse("1234567890123456");

export const enviromentUrl = `${baseurl}${API_URL}`;

export const jwtToken = localStorage.getItem('jwtToken');
export const loginId = localStorage.getItem('loginId');
export const CustomerId = localStorage.getItem('CustomerId');

export const decryptString = (encryptedData, key, iv) => {
    const decrypteData = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Base64.parse(encryptedData) },
        key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );

    const result = decrypteData.toString(CryptoJS.enc.Utf8);
    return result;
};

export const getProductDataById = async() => {
    const pId = localStorage.getItem('SAproductId');
    try {
        const response = await axios.get(`${baseurl}${API_URL.GetProductDetailById}?pProductDetailId=${pId}`);

        const encryptedData = response.data.data;

        if (!encryptedData || typeof encryptedData !== 'string' || encryptedData.trim() === '') {
            toast.error("Invalid or empty encrypted data format");
        }

        const result = decryptString(encryptedData, secretKey, iv);

        const parsedData = JSON.parse(result);

        if (response.status === 200 && response.data.isSuccess === 200) {
            return parsedData;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
};

export const getCategoryData = async() => {
    try {
        const response = await axios.get(`${baseurl}${API_URL?.GetProductCategory}`);

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                return response.data.data;
            }
        } else {
            toast.error("Failed to fetch Category Data");
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const getSubCategoryData = async() => {
    try {
        const response = await axios.get(`${baseurl}${API_URL?.GetProductSubCategory}`);

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                return response.data.data;
            }
        } else {
            toast.error("Failed to fetch Category Data");
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const GetProductSubCategoryByCategoryId = async(pProductCategoryId) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL.GetProductSubCategoryByCategoryId}?pProductCategoryId=${pProductCategoryId}`);

        if (response.status === 200) {
            return response.data;
        } else {
            toast.error("FFailed to fetch product image Data");
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const GetProductSubCategoryByMultiCategoryId = async(pProductCategoryId) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL.GetProductSubCategoryByMultiCategoryId}?pProductCategoryId=${pProductCategoryId}`);

        if (response.status === 200) {
            return response.data;
        } else {
            toast.error("FFailed to fetch product image Data");
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const getTexType = async() => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {
        const response = await axios.get(`${baseurl}${API_URL?.GetTaxType}`, {
            headers: {
                'Authorization': `Bearer ${jwtToken}`,
            },
        });

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                return response.data.data;
            }
        } else {
            toast.error("Failed to fetch Category Data");
        }
    } catch (error) {
        console.error("Please try again later.");
    }
};

export const onSaveProductDetail = async(formData) => {

    try {
        const response = await axios.post(`${baseurl}${API_URL?.SaveProductDetail}`, formData, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                toast.success("Data Save successfully");
                return response.data;
            } else {
                toast.error("Save failed");
            }
        } else {
            toast.error("Failed");
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const IsFavProductDetailById = async(productId) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL?.IsFavProductDetailById}`, {
            params: {
                pProductDetailId: productId,
            },
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            toast.success("Update Successfully");
            return response.data;
        } else {
            toast.error("Failed to Update category");
            return null;
        }
    } catch (error) {
        toast.error("Please try again later.");
        return null;
    }
};

export const IsStockProductDetailById = async(productId) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL?.IsStockProductDetailById}`, {
            params: {
                pProductDetailId: productId,
            },
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            toast.success("Update Successfully");
            return response.data;
        } else {
            toast.error("Failed to Update category");
            return null;
        }
    } catch (error) {
        toast.error("Please try again later.");
        return null;
    }
};

export const getProductImages = async() => {
    try {
        const response = await axios.get(`${baseurl}${API_URL?.GetProductImageAll}`);

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                return response.data.data;
            }
        } else {
            toast.error("FFailed to fetch product image Data");
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const onSaveProductImages = async(formData) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL?.SaveProductImage}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // FormData header
            },
        });

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                toast.success("Data saved successfully");
                return response.data;
            } else {
                toast.error("Save failed");
            }
        } else {
            toast.error("Failed");
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const onDeleteProductImages = async(item) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this item?");

    if (!isConfirmed) {
        return;
    }

    try {
        const response = await axios.get(`${baseurl}${API_URL?.DeleteProductImageById}`, {
            params: {
                pProductImageId: item.productImageId
            }
        });

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                toast.success("Delete successfully");
                return response.data;
            } else {
                toast.error("Delete failed");
            }
        } else {
            toast.error("Failed");
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const getProductImageByProductId = async() => {
    const pId = localStorage.getItem('SAproductId');
    try {

        const response = await axios.get(`${baseurl}${API_URL.GetProductImageByProductId}?pProductId=${pId}`);

        if (response.status === 200) {
            if (response.data.isSuccess === 200 && response.data.data != null) {
                return response.data.data;
            }
        } else {
            toast.error("FFailed to fetch product image Data");
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const getProductSpecificationByProductId = async() => {
    const pId = localStorage.getItem('SAproductId');
    try {

        const response = await axios.get(`${baseurl}${API_URL.GetProductSpecificationByProductId}?pProductId=${pId}`);

        if (response.status === 200) {
            if (response.data.isSuccess === 200 && response.data.data !== null) {
                return response.data.data;
            }
        } else {
            toast.error("FFailed to fetch product image Data");
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const getSpecificationData = async() => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {
        const response = await axios.get(`${baseurl}${API_URL.getSpecification}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                return response.data.data;
            }
        } else {
            console.error("FFailed to fetch product image Data");
        }
    } catch (error) {
        console.error("Please try again later.");
    }
};

export const GetSpecificationByProductCategoryId = async(id) => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {
        const response = await axios.get(`${baseurl}${API_URL.GetSpecificationByProductCategoryId}?pProductCategoryId=${id}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                return response.data.data;
            }
        } else {
            console.error("FFailed to fetch product image Data");
        }
    } catch (error) {
        console.error("Please try again later.");
    }
};

export const onSaveProductSpecification = async(formData) => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {
        const response = await axios.post(`${baseurl}${API_URL?.SaveProductSpecification}`, formData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                toast.success("Data saved successfully");
                return response.data;
            } else {
                toast.error("Save failed");
            }
        } else {
            toast.error("Failed");
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const onDeleteProductSpecification = async(item) => {
    const jwtToken = localStorage.getItem('jwtToken');
    const isConfirmed = window.confirm("Are you sure you want to delete this item?");

    if (!isConfirmed) {
        return;
    }

    try {
        const response = await axios.get(`${baseurl}${API_URL?.DeleteProductSpecificationById}`, {
            params: {
                pProductSpecificationId: item.productSpecificationId
            },
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                toast.success("Delete successfully");
                return response.data;
            } else {
                toast.error("Delete failed");
            }
        } else {
            toast.error("Failed");
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const isDisplayProductSpecificationById = async(item) => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {
        const response = await axios.get(`${baseurl}${API_URL?.IsDisplayProductSpecificationById}`, {
            params: {
                pProductSpecificationId: item.productSpecificationId
            },
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });
        if (response.status === 200 && response.data.isSuccess === 200) {
            toast.success("Update Successfully");
            return response.data;
        } else {
            toast.error("Failed to Update category");
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
}

export const isActiveProductSpecificationById = async(item) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL?.ActiveProductSpecificationById}`, {
            params: {
                pProductSpecificationId: item.productSpecificationId,
            },
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            toast.success("Update Successfully");
            return response.data; // Return response data if successful
        } else {
            toast.error("Failed to Update category");
            return null; // Return null in case of failure
        }
    } catch (error) {
        toast.error("Please try again later.");
        return null; // Return null in case of error
    }
};

// Function to get the application list
export const getCouponCodeList = async() => {
    const jwtToken = localStorage.getItem('jwtToken');

    if (!jwtToken) {
        toast.error("JWT Token is missing");
    }

    try {
        const response = await axios.get(`${baseurl}${API_URL?.GetCoupon}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            if (response.data.isSuccess === 200 && response.data.data.length > 0) {
                return response.data.data;
            } else {
                return [];
            }
        } else {
            console.error('API request was not successful:', response.status);
            return [];
        }
    } catch (error) {
        toast.error("Failed to fetch coupon list");
    }
};

export const createCouponCode = async(formData) => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {
        const response = await axios.post(
            `${baseurl}${API_URL.SaveCoupon}`,
            formData, {
                headers: {
                    'Authorization': `Bearer ${jwtToken}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response;
    } catch (error) {
        throw error;
    }
};

export const isActiveToggle = async(id) => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {
        const response = await axios.get(`${baseurl}${API_URL?.ActiveCouponById}`, {
            params: {
                pCouponId: id
            },
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                return response;
            }
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const isDelete = async(id) => {
    const jwtToken = localStorage.getItem('jwtToken');

    const isConfirmed = window.confirm("Are you sure you want to delete this item?");
    if (!isConfirmed) {
        return;
    }

    try {
        const response = await axios.get(`${baseurl}${API_URL?.DeleteCouponById}`, {
            params: {
                pCouponId: id
            },
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });
        return response;
    } catch (error) {
        toast.error("Please try again later.");
    }
};

/*Blog API */
export const SaveBlogDetail = async(formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveBlogDetail}`, formdata, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
}

export const getBlogDetailAll = async() => {
    try {
        const response = await axios.get(`${baseurl}${API_URL.GetBlogDetail}`);

        if (response.status === 200 && response.data.isSuccess === 1) {
            return response.data.data;
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};
export const deleteBlogDetailById = async(id) => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.DeleteBlogDetailById + "?pBlogDetailId=" + id}`);

            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            toast.error(error.message || "Please try again later.");
        }
    }
    /*Blog API */

export const GetMenuDetailByTypeId = async(pMenuTypeId, pRoleId) => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {

        const response = await axios.get(`${baseurl}${API_URL.GetMenuDetailByTypeId + "?pMenuTypeId=" + pMenuTypeId + "&pRoleId=" + pRoleId}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

// contact enquiry 
export const GetEnquiryAll = async() => {
    try {
        const response = await axios.get(`${baseurl}${API_URL.GetEnquiryAll}`);

        if (response.status === 200 && response.data.isSuccess === 1) {
            return response.data.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const deleteEnquiryById = async(id) => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.DeleteEnquiryById + "?pEnquiryId=" + id}`);

            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            toast.error(error.message || "Please try again later.");
        }
    }
    // end contact enquiry 

// faqs data
export const getFaqDetailAll = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetFaqDetailAll);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const SaveFaqDetail = async(formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveFaqDetail}`, formdata, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const deleteFaqDetailById = async(id) => {
        try {
            const response = await axiosIns.get(`${API_URL.DeleteFaqDetailById}?pFaqDetailId=${id}`);

            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            toast.error(error.message || "Please try again later.");
        }
    }
    // end faqs data

// Order detail 
export const getProductOrderDetail = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetProductOrderDetail);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const updatePaymentResponse = async(id) => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {

        const response = await axiosIns.get(`${API_URL.UpdatePaymentResponse}?OrderId=${id}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200 && response.data.isSuccess === 1) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const createShipment = async(formdata) => {
        try {
            const response = await axiosIns.post(`${API_URL.CreateShipment}`, formdata, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 200 && response.data.isSuccess === 200) {
                return response.data;
            }
        } catch (error) {
            toast.error(error.message || "Please try again later.");
        }
    }
    // Order detail 

// customer detail
export const GetLoginDetailAll = async() => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {
        const response = await axiosIns.get(`${API_URL.GetLoginDetailAll}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const DeleteLoginDetailById = async(id) => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {
        const response = await axiosIns.get(`${API_URL.DeleteLoginDetailById}?pLoginDetailId=${id}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const GetProductOrderByLoginId = async() => {
    const jwtToken = localStorage.getItem('jwtToken');
    const CustomerId = localStorage.getItem('CustomerId');
    try {
        const response = await axiosIns.get(`${API_URL.GetProductOrderByLoginId}?pLoginId=${CustomerId}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const GetProductOrderDetail = async() => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {
        const response = await axiosIns.get(`${API_URL.GetProductOrderDetail}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const GetProductOrderSummary = async() => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {
        const response = await axiosIns.get(`${API_URL.GetProductOrderSummary}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const GetProductOrderDetailMonthly = async() => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {
        const response = await axiosIns.get(`${API_URL.GetProductOrderDetailMonthly}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const GetLoginDetailById = async() => {
    const jwtToken = localStorage.getItem('jwtToken');
    const CustomerId = localStorage.getItem('CustomerId');
    try {
        const response = await axiosIns.get(`${API_URL.GetLoginDetailById}?pLoginDetailId=${CustomerId}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const GetProductOrderByOrderId = async(productId) => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {
        const response = await axiosIns.get(`${API_URL.GetProductOrderByOrderId}?pProductOrderId=${productId}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const GetMemberLoginById = async() => {
    const jwtToken = localStorage.getItem('jwtToken');
    const loginId = localStorage.getItem('loginId');
    try {
        const response = await axiosIns.get(`${API_URL.GetMemberLoginById}?pMemberLoginId=${loginId}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

// product offer banner
export const SaveProductOffer = async(formData) => {

    try {
        const response = await axios.post(`${baseurl}${API_URL?.SaveProductOffer}`, formData);

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                toast.success("Data Save successfully");
                return response.data;
            }
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const GetProductOfferAll = async() => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {
        const response = await axiosIns.get(`${API_URL.GetProductOffer}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200 && response.data.isSuccess === 1) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const ActiveProductOfferById = async(offerId) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL?.ActiveProductOfferById}`, {
            params: {
                pProductOfferId: offerId,
            },
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            toast.success("Update Successfully");
            return response.data;
        }
    } catch (error) {
        toast.error("Please try again later.");
        return null;
    }
};

export const DeleteProductOfferById = async(id) => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {
        const response = await axiosIns.get(`${API_URL.DeleteProductOfferById}?pProductOfferId=${id}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const GetDashboardSummary = async() => {
    try {
        const response = await axios.get(`${baseurl}${API_URL.GetDashboardSummary}`);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

// CancelType data
export const GetCancelTypeAll = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetCancelType);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const SaveCancelType = async(formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveCancelType}`, formdata, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const ActiveCancelTypeById = async(id) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL?.ActiveCancelTypeById}`, {
            params: {
                pCancelTypeId: id
            },
        });

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                return response.data;
            }
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const IsRefundCancelTypeById = async(id) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL?.IsRefundCancelTypeById}`, {
            params: {
                pCancelTypeId: id
            },
        });

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                return response.data;
            }
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const DeleteCancelTypeById = async(id) => {
        try {
            const response = await axiosIns.get(`${API_URL.DeleteCancelTypeById}?pCancelTypeId=${id}`);

            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            toast.error(error.message || "Please try again later.");
        }
    }
    // end CancelType data

// RetrunType data
export const GetRetrunTypeAll = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetRetrunType);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const SaveRetrunType = async(formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveRetrunType}`, formdata, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const ActiveRetrunTypeById = async(id) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL?.ActiveRetrunTypeById}`, {
            params: {
                pRetrunTypeId: id
            },
        });

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                return response.data;
            }
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const DeleteRetrunTypeById = async(id) => {
        try {
            const response = await axiosIns.get(`${API_URL.DeleteRetrunTypeById}?pRetrunTypeId=${id}`);

            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            toast.error(error.message || "Please try again later.");
        }
    }
    // end RetrunType data

// ProductRating data

export const SaveProductRating = async(formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveProductRating}`, formdata, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const GetProductRatingAll = async() => {
    const jwtToken = localStorage.getItem('jwtToken');
    try {
        const response = await axiosIns.get(`${API_URL.GetProductRatingAll}`, {
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const DeleteProductRatingById = async(id) => {
    try {
        const response = await axiosIns.get(`${API_URL.DeleteProductRatingById}?pProductRatingId=${id}`);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

// ProductRating data end


export const IsHeaderProductImageById = async(item) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL?.IsHeaderProductImageByProductImageId}`, {
            params: {
                pProductImageId: item.productImageId,
                pProductId: item.productId
            },
        });

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                return response.data;
            }
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const IsDisplayProductImageById = async(id) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL?.IsDisplayProductImageById}`, {
            params: {
                pProductImageId: id
            },
        });

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                return response.data;
            }
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

export const ActiveProductImageById = async(id) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL?.ActiveProductImageById}`, {
            params: {
                pProductImageId: id
            },
        });

        if (response.status === 200) {
            if (response.data.isSuccess === 200) {
                return response.data;
            }
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
};

// colors data
export const GetColorTypeAll = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetColorType);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(error.message || "Please try again later.");
    }
}

export const GetColorType = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetColorType);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(error.message || "Please try again later.");
    }
}

export const SaveColorsType = async(formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveColorType}`, formdata, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const deleteColorTypeById = async(id) => {
        try {
            const response = await axiosIns.get(`${API_URL.DeleteColorTypeById}?pColorTypeId=${id}`);

            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            toast.error(error.message || "Please try again later.");
        }
    }
    // end colors data

// size type data
export const GetSizeTypeAll = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetSizeType);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(error.message || "Please try again later.");
    }
}

export const GetSizeType = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetSizeType);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(error.message || "Please try again later.");
    }
}

export const SaveSizeType = async(formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveSizeType}`, formdata, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const deleteSizeTypeById = async(id) => {
        try {
            const response = await axiosIns.get(`${API_URL.DeleteSizeTypeById}?pSizeTypeId=${id}`);

            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            toast.error(error.message || "Please try again later.");
        }
    }
    // end size type data

// stock detail
export const GetStockDetailAll = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetStockDetail);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(error.message || "Please try again later.");
    }
}

export const SaveStockDetail = async(formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveStockDetail}`, formdata, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const DeleteStockDetailById = async(id) => {
        try {
            const response = await axiosIns.get(`${API_URL.DeleteStockDetailById}?pStockDetailId=${id}`);

            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            toast.error(error.message || "Please try again later.");
        }
    }
    // end stock detail 

// banner type detail
export const GetBannerTypeAll = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetBannerType);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(error.message || "Please try again later.");
    }
}

export const SaveBannerType = async(formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveBannerType}`, formdata, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const DeleteBannerTypeById = async(id) => {
        try {
            const response = await axiosIns.get(`${API_URL.DeleteBannerTypeById}?pBannerTypeId=${id}`);

            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            toast.error(error.message || "Please try again later.");
        }
    }
    // end banner type detail 

// banner detail
export const GetBannerAll = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetBanner);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(error.message || "Please try again later.");
    }
}

export const SaveBanner = async(formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveBanner}`, formdata, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const DeleteBannerById = async(id) => {
        try {
            const response = await axiosIns.get(`${API_URL.DeleteBannerById}?pBannerId=${id}`);

            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            toast.error(error.message || "Please try again later.");
        }
    }
    // end banner detail 

export const ImportTemplate = async(formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.ImportTemplate}`, formdata, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            toast.success("File uploaded successfully.");
            return response.data;
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    } catch (error) {
        toast.error(error.message || "An error occurred. Please try again later.");
    }
};

export const UploadProductImages = async(formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.UploadProductImages}`, formdata, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        if (response.status === 200) {
            return response.data;
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    } catch (error) {
        toast.error(error.message || "An error occurred. Please try again later.");
    }
};

export const GetImage = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetImage);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(error.message || "Please try again later.");
    }
}

//Product sku detail
export const GetProductSkuAll = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetProductSkuAll);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(error.message || "Please try again later.");
    }
}

export const GetProductSkuByProductId = async(productId) => {
    try {

        const response = await axiosIns.get(`${API_URL.GetProductSkuByProductId}?pProductId=${productId}`);

        if (response.status === 200) {
            return response.data;
        } else {
            console.error('Failed to fetch product SKU data');
        }
    } catch (error) {
        console.error(error.message || "Please try again later.");
    }
}

export const SaveProductSku = async(formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveProductSku}`, formdata, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
}

export const DeleteProductSkuById = async(id) => {
        try {
            const response = await axiosIns.get(`${API_URL.DeleteProductSkuById}?pProductSkuId=${id}`);

            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            toast.error(error.message || "Please try again later.");
        }
    }
    // end product sku detail 

export const UploadImages = async(formdata, productId, skuId) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.UploadImages}?pProductId=${productId}&pSkuId=${skuId}`, formdata, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        if (response.status === 200) {
            return response.data;
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    } catch (error) {
        toast.error(error.message || "An error occurred. Please try again later.");
    }
};

export const GetStoctSummary = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetStoctSummary);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(error.message || "Please try again later.");
    }
}

export const GetCustomOrderAll = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetCustomOrderAll);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(error.message || "Please try again later.");
    }
}

export const GetCustomOrder = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetCustomOrder);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(error.message || "Please try again later.");
    }
}

export const DeleteCustomOrderById = async(id) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL.DeleteCustomOrderById + "?pCustomOrderId=" + id}`);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const GetProductCancel = async() => {
    try {
        const response = await axiosIns.get(`${API_URL.GetProductCancel}`);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const DeleteProductCancelById = async(id) => {
    try {
        const response = await axiosIns.get(`${API_URL.DeleteProductCancelById}?pProductCancelId=${id}`);

        if (response.status === 1) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

// weight type data

export const GetWeightType = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetWeightType);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(error.message || "Please try again later.");
    }
}

export const SaveWeightType = async(formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveWeightType}`, formdata, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const DeleteWeightTypeById = async(id) => {
        try {
            const response = await axiosIns.get(`${API_URL.DeleteWeightTypeById}?pWeightTypeId=${id}`);

            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            toast.error(error.message || "Please try again later.");
        }
    }
    // end weight type data

// shape type data

export const GetShapeType = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetShapeType);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(error.message || "Please try again later.");
    }
}

export const SaveShapeType = async(formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveShapeType}`, formdata, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const DeleteShapeTypeById = async(id) => {
        try {
            const response = await axiosIns.get(`${API_URL.DeleteShapeTypeById}?pShapeTypeId=${id}`);

            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            toast.error(error.message || "Please try again later.");
        }
    }
// end shape type data
    
// static page data

export const GetStaticPageDescription = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetStaticPageDescription);

        if (response?.data?.isSuccess === 1) {
            return response.data;
        }
    } catch (error) {
        console.error(error.message || "Please try again later.");
    }
}

// export const GetStaticPageDescriptionById = async() => {
//     try {
//         const response = await axiosIns.get(API_URL.GetStaticPageDescriptionById);

//         if (response?.data?.isSuccess === 1) {
//             return response.data;
//         }
//     } catch (error) {
//         console.error(error.message || "Please try again later.");
//     }
// }

export const SaveStaticPageDescription = async(formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveStaticPageDescription}`, formdata, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status === 200 && response.data.isSuccess === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
}

export const DeleteStaticPageDescriptionById = async(id) => {
        try {
            const response = await axiosIns.get(`${API_URL.DeleteStaticPageDescriptionById}?pStaticPageDescriptionId=${id}`);

            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            toast.error("Please try again later.");
        }
    }
// static page data

export const GetStaticPage = async() => {
    try {
        const response = await axiosIns.get(API_URL.GetStaticPage);

        if (response?.data?.isSuccess === 1) {
            return response.data;
        }
    } catch (error) {
        console.error("Please try again later.");
    }
}

/*social Video API */
export const SaveSocialVideo = async (formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveSocialVideo}`, formdata, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        );

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
}

export const GetSocialVideo = async () => {
    try {
        const response = await axios.get(`${baseurl}${API_URL.GetSocialVideoAll}`);

        if (response.status === 200 && response.data.isSuccess === 1) {
            return response.data.data;
        }
    } catch (error) {
        console.error("Please try again later.");
    }
};

export const DeleteSocialVideoById = async (id) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL.DeleteSocialVideoById + "?pSocialVideoId=" + id}`);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}
/*social Video API */

/*Insta Feed API */
export const SaveInstaFeed = async (formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveInstaFeed}`, formdata, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        );

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
}

export const GetInstaFeed = async () => {
    try {
        const response = await axios.get(`${baseurl}${API_URL.GetInstaFeedAll}`);

        if (response.status === 200 && response.data.isSuccess === 1) {
            return response.data.data;
        }
    } catch (error) {
        console.error("Please try again later.");
    }
};

export const DeleteInstaFeedById = async (id) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL.DeleteInstaFeedById + "?pInstaFeedId=" + id}`);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}
/*Insta Feed API */

/*Celeb Section API */
export const SaveCelebSection = async (formdata) => {
    try {
        const response = await axios.post(`${baseurl}${API_URL.SaveCelebSection}`, formdata, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        );

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error("Please try again later.");
    }
}

export const GetCelebSection = async () => {
    try {
        const response = await axios.get(`${baseurl}${API_URL.GetCelebSectionAll}`);

        if (response.status === 200 && response.data.isSuccess === 1) {
            return response.data.data;
        }
    } catch (error) {
        console.error("Please try again later.");
    }
};

export const DeleteCelebSectionById = async (id) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL.DeleteCelebSectionById + "?pCelebSectionId=" + id}`);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}
/*Celeb Section API */

// contact enquiry 
export const GetCustomEnquiry = async () => {
    try {
        const response = await axios.get(`${baseurl}${API_URL.GetCustomEnquiry}`);

        if (response.status === 200 && response.data.isSuccess === 1) {
            return response.data.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}

export const DeleteCustomEnquiryById = async (id) => {
    try {
        const response = await axios.get(`${baseurl}${API_URL.DeleteCustomEnquiryById + "?pCustomEnquiryId=" + id}`);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        toast.error(error.message || "Please try again later.");
    }
}
// end contact enquiry 